export enum MfaVerifyOutcome {
    Verified = "verified",
    InvalidCode = "invalid_code",
    Expired = "expired",
    TooManyAttempts = "too_many_attempts",
    Unavailable = "unavailable"
}

/** Only sign-in offers "Trust this browser"; account actions are already signed in, so their copy drops "sign in". */
export enum MfaPromptPurpose {
    SignIn = "sign_in",
    AccountAction = "account_action"
}

/** What the caller plugs in, so login and account actions can share the same two steps. */
export interface IMfaPromptOptions {
    purpose: MfaPromptPurpose;
    sendCode: (contact: string) => Promise<void>;
    verifyCode: (code: string, trustBrowser: boolean) => Promise<MfaVerifyOutcome>;
}

export interface IMfaPrompt {
    /** Resolves true once a code is verified, or false if the customer closes the prompt or the challenge expires. */
    promptAsync(options: IMfaPromptOptions): Promise<boolean>;
    /** Tells the customer why MFA can't continue (expired, out of attempts, or unavailable); other outcomes show nothing. */
    showEndingMessage(outcome: MfaVerifyOutcome): void;
}
